import { fileActionTypes } from 'store/actionTypes';
import api from 'utils/api';

export const uploadFiles = (model, formData, rowId) => async dispatch => {
  try {
    dispatch({ type: fileActionTypes.UPLOAD_FILES_START });
    await api.post(`${model}/upload-file/${rowId}`, formData);
    dispatch({ type: fileActionTypes.UPLOAD_FILES });
  } catch (err) {
    dispatch({ type: fileActionTypes.UPLOAD_FILES_ERROR, payload: err });
  }
};

export const deleteFile = (model, id, rowId) => async dispatch => {
  try {
    dispatch({ type: fileActionTypes.DELETE_FILE_START });
    await api.post(`${model}/delete-file`, { id, rowId });
    dispatch({ type: fileActionTypes.DELETE_FILE });
  } catch (err) {
    dispatch({ type: fileActionTypes.DELETE_FILE_ERROR, payload: err });
  }
};

export const uploadAvatar = formData => async dispatch => {
  try {
    dispatch({ type: fileActionTypes.UPLOAD_AVATAR_START });
    await api.post('/client/profile/upload-avatar', formData);
    dispatch({ type: fileActionTypes.UPLOAD_AVATAR });
  } catch (err) {
    dispatch({ type: fileActionTypes.UPLOAD_AVATAR_ERROR, payload: err });
  }
};
